/* eslint-disable @typescript-eslint/naming-convention */
import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag, Size } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { useScreenSize } from '@ps/web-shared-components';
import classNames from 'clsx';
import { isNumber } from 'lodash';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Iframe from '@swf/components/Iframe/Iframe';
import SessionTimer from '@swf/components/SessionTimer/SessionTimer';
import { select } from '@swf/core/store';

import type { Props } from '../../TopHeader';
import RegulatoryHeaderCZ from '../RegulatoryHeaderCZ/RegulatoryHeaderCZ';
import RegulatoryHeaderPA from '../RegulatoryHeaderPA/RegulatoryHeaderPA';
import RegulatoryHeaderPT from '../RegulatoryHeaderPT/RegulatoryHeaderPT';
import RegulatoryHeaderSE from '../RegulatoryHeaderSE/RegulatoryHeaderSE';
import RegulatoryHeaderUS from '../RegulatoryHeaderUS/RegulatoryHeaderUS';
import RegulatoryHeaderUSMI from '../RegulatoryHeaderUSMI/RegulatoryHeaderUSMI';

import DKHeaderContent from './DKHeaderContent/DKHeaderContent';
import styles from './SessionHeader.scss';

const SessionHeader: React.FC<Props> = ({ regulatory_header }) => {
  const site = useSelector(select.cms.getSiteId);
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const { userSessionStartTime } = useSelector(select.account.getLoginLimitInfo);
  const useRam1 = useFeature(FeatureFlag.UseRam1);
  const location = useSelector(select.location.get);
  const [iframeError, setIframeError] = useState(false);
  const isPortugalPSN = Sites.PT_PS_EXT === site;
  const { greaterThan } = useScreenSize();

  const licenseContent: Partial<Record<Sites, JSX.Element>> = {
    [Sites.PT_PS_EXT]: <RegulatoryHeaderPT regulatory_header={regulatory_header} />,
    [Sites.POR]: <RegulatoryHeaderPT regulatory_header={regulatory_header} />,
    [Sites.DEN]: <DKHeaderContent regulatory_header={regulatory_header} />,
    [Sites.SWE]: <RegulatoryHeaderSE regulatory_header={regulatory_header} />,
    [Sites.CZE]: <RegulatoryHeaderCZ regulatory_header={regulatory_header} />,
    [Sites.US_PA]: <RegulatoryHeaderPA regulatory_header={regulatory_header} />,
    [Sites.USMI]: <RegulatoryHeaderUSMI regulatory_header={regulatory_header} />,
    [Sites.US_NJ]: <RegulatoryHeaderUS regulatory_header={regulatory_header} />,
    [Sites.US_CO]: <RegulatoryHeaderUS regulatory_header={regulatory_header} />
  };

  return (
    <>
      <div
        className={classNames(styles.sessionHeader, {
          [styles.us]: [Sites.US_PA, Sites.USMI].includes(site),
          [styles.columnLayout]: isPortugalPSN && !greaterThan(Size.Medium)
        })}
      >
        {isAuthenticated && isNumber(userSessionStartTime) && !useRam1 && (
          <SessionTimer
            className={classNames(styles.sessionDuration, {
              [styles.multilineHeader]: site === Sites.SWE,
              [styles.multilineSessionHeader]: site === Sites.SWE
            })}
            showLimit={site === Sites.CZE}
          />
        )}
        {isAuthenticated && isPortugalPSN && !iframeError && (
          <Iframe
            data-testid="session-iframe"
            src={`${location.origin}/pam/psn-auth-adapter/ui/partner-content?pageId=SESSION_TIMER`}
            onError={() => setIframeError(true)}
            onLoad={() => setIframeError(false)}
            className={styles.externalTimer}
          />
        )}
      </div>
      {licenseContent[site]}
    </>
  );
};

export default SessionHeader;
